import { useQuery } from '@tanstack/react-query';
import {
    fetchRefinementTarget,
    type RefinementTarget
} from '../../../../../services/refinementTarget';
import { REFINEMENT_TARGET_KEY } from '../../../../../hooks/queryKeys';

export function useRefinementTarget(patientId: string): RefinementTarget | null {
    const { data } = useQuery({
        queryKey: REFINEMENT_TARGET_KEY(patientId),
        queryFn: () => fetchRefinementTarget(patientId)
    });
    return data ?? null;
}
